import { DivAlert } from "components/display/DivAlert";
import styled, { css } from "styled-components";

export const CustomDivAlert = styled(DivAlert)`
  margin: 0.2rem 0rem;

  b {
    margin-top: 0.4rem;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 1.2rem;
  }
`;

export const SummarySection = styled.div`
  padding: 1.5rem;
  background-color: var(--black-200);
  border-bottom: 1px solid #3d3d3d;

  .payment-header {
    margin-bottom: 0.5rem;

    h3 {
      margin-bottom: 0.4rem;
    }
  }
`;

export const PaymentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 1rem;
  column-gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .active-input {
    border: 2px solid var(--green);
    border-radius: 4px;
  }
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  column-gap: 1rem;
`;

export const PaymentSection = styled.div`
  padding: 1.5rem;

  button {
    width: 100%;

    transition: opacity 0.3s;

    &:hover:enabled {
      opacity: 0.8;
    }
  }

  &:last-of-type {
    padding-bottom: 3.6rem;
  }

  .payment-header {
    p {
      color: var(--grey-100);
      font-size: 0.95rem;
    }

    h3 {
      margin-bottom: 0.3rem !important;
    }

    margin-bottom: 1.2rem;
  }

  ${FormRow} {
    display: flex;
    flex-direction: row;
    margin: 0.5rem 0rem;
  }
`;

export const DeactivatedFormGroupTitle = styled.span`
  position: absolute;
  left: auto;
  top: auto;
  right: auto;
  bottom: auto;
  font-family: Inter, sans-serif;
  display: none;
`;

type FormGroupProps = {
  isDeactivated: boolean;
};

export const FormGroup = styled.div<FormGroupProps>`
  margin-bottom: 1.3rem;

  ${({ isDeactivated }) =>
    isDeactivated &&
    css`
      background-color: var(--black-100);
      border: 2px dashed var(--grey-100);
      border-radius: 4px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      ${PaymentContainer} {
        visibility: hidden;
      }

      ${DeactivatedFormGroupTitle} {
        display: block;
      }
    `}
`;

export const SuperficialPolicemanContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 0.5rem;
  background-color: var(--black-300);
  border-radius: 4px;
  border: 1px solid var(--grey-100);
`;

export const PaymentFormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
  column-gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
